export default __webpack_public_path__ + "static/media/favwidget.ebde01bb.png";